const defaultConfig = {
  mapTo: value => value,
  sortBy: () => {},
};

const sortByOrdinal = (a, b) => {
  return a.ordinal - b.ordinal;
}

const mapToMenu = ({
  itens: items,
  route: { name, path, icon },
  ...rest
}) => ({
  label: name,
  items: !items.length ? null : items,
  to: path,
  icon,
  ...rest
});

const nest = (items, config = defaultConfig, id = 0, link = 'parent') => {
  return items
    .filter(item => item[link] === id)
    .map(item => ({ ...item, itens: nest(items, config, item.id) }))
    .map(config.mapTo)
    .sort(config.sortBy)
    .sort(sortByOrdinal);
}

export {
  nest,
  mapToMenu,
}
